import type { Cart } from '@/modules/cart/domain/Cart';
import { EShippingSubType, EShippingType } from '@/modules/cart/domain/Cart';

export const verifyHasSomeHomeDelivery = (cart: Cart) => {
  if (!cart?.deliveryInfo?.deliveryGroups?.length) return false;

  return cart?.deliveryInfo?.deliveryGroups?.some((group) => {
    const shippingType = group?.shippingOption?.shippingType;
    const shippingSubType = group?.shippingOption?.shippingSubType;

    const isDelivery = shippingType === EShippingType.DELIVERY;
    const isHomeDelivery = shippingSubType === EShippingSubType.HOME;

    return isDelivery && isHomeDelivery;
  });
};

export default verifyHasSomeHomeDelivery;
